import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, OnInit, ViewChild, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import * as objectPath from 'object-path';
import { filter } from 'rxjs/operators';
import { ClassInitService, LayoutConfigService, PageConfigService, SplashScreenService } from './content/layout/services';
import { MatIconRegistry } from '@angular/material';
import {PreCargaService} from './content/pages/components/roteirizacao/services/pre-carga.service';
import {MensagensService} from 'max-ng-lib';
@Component({
  selector: 'body[rot-root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class AppComponent implements AfterViewInit, OnInit {
  title = 'maxroteirizador-angular';

  @HostBinding('style') style: any;
  @HostBinding('class') classes: any = '';

  @ViewChild('splashScreen', { read: ElementRef, static: false }) splashScreen: ElementRef;
  splashScreenImage: string;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private layoutConfigService: LayoutConfigService,
    private classInitService: ClassInitService,
    private splashScreenService: SplashScreenService,
    private pageConfigService: PageConfigService,
    private matIconRegistry: MatIconRegistry,
    private precargaService: PreCargaService,
    private messageService: MensagensService
  ) {
    this.matIconRegistry.addSvgIcon(
      'fmd_bad',
      this.sanitizer.bypassSecurityTrustResourceUrl('../assets/img/icons/sem-local.svg')
    );
    // subscribe to class update event
    this.classInitService.onClassesUpdated$.subscribe(classes => {
      // get body class array, join as string classes and pass to host binding class
      setTimeout(() => this.classes = classes.body.join(' '));
    });

    this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {
      this.classInitService.setConfig(model);

      this.style = '';
      if (objectPath.get(model.config, 'self.layout') === 'boxed') {
        const backgroundImage = objectPath.get(model.config, 'self.background');
        if (backgroundImage) {
          this.style = this.sanitizer
            .bypassSecurityTrustStyle('background-image: url(' + objectPath.get(model.config, 'self.background') + ')');
        }
      }

      this.splashScreenImage = objectPath.get(model.config, 'loader.image');
    });

    // register translations
    // this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);

    // override config by router change from pages config
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.layoutConfigService.setModel({ page: objectPath.get(this.pageConfigService.getCurrentPageConfig(), 'config') }, true);
      });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.splashScreen) {
      this.splashScreenService.init(this.splashScreen.nativeElement);
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'F11') {
    } else {
    }

  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
   if (this.precargaService.existePrecargaEmProcessoSalvar()) {
     this.messageService.exibaToastAlerta('Existem Pré-Cargas em processo de salvamento. Aguarde a finalização.');
     event.preventDefault();
     event.returnValue = 'Existem Pré-Cargas em processo de salvamento. Deseja realmente sair?';
    }
  }
}
